
(function() {
  var result = { translations: { "bg": { "i18n": { "duration": { "seconds": "{{ seconds }} \u0441\u0435\u043A", "minutes": "{{ minutes }} \u043C\u0438\u043D", "hours": "{{ hours }} \u0447", "hoursAndMinutes": "{{ hours }} \u0447 {{ minutes }} \u043C\u0438\u043D", "days": "{{ days }} \u0434\u043D\u0438", "shortForm": { "seconds": "{{ seconds }} \u0441\u0435\u043A", "minutes": "{{ minutes }} \u043C\u0438\u043D", "hours": "{{ hours }} \u0447", "days": "{{ days }} \u0434", "hoursAndMinutes": "{{ hours }} \u0447 {{ minutes }} \u043C\u0438\u043D" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \u0432\u044A\u0442\u0440. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "bg": "static-7.1082"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1082",
    "ar-eg": "static-7.1082",
    "bg": "static-7.1082",
    "bn": "static-7.1082",
    "ca-es": "static-7.1082",
    "cs": "static-7.1082",
    "da": "static-7.1082",
    "de": "static-7.1082",
    "el": "static-7.1082",
    "en-gb": "static-7.1082",
    "en": "static-7.1082",
    "es-mx": "static-7.1082",
    "es": "static-7.1082",
    "et": "static-7.1082",
    "fi": "static-7.1082",
    "fr-ca": "static-7.1082",
    "fr": "static-7.1082",
    "he-il": "static-7.1082",
    "hi": "static-7.1082",
    "hr": "static-7.1082",
    "hu": "static-7.1082",
    "id": "static-7.1082",
    "it": "static-7.1082",
    "ja": "static-7.1082",
    "ko": "static-7.1082",
    "lt": "static-7.1082",
    "ms": "static-7.1082",
    "nl": "static-7.1082",
    "no": "static-7.1082",
    "pl": "static-7.1082",
    "pt-br": "static-7.1082",
    "pt-pt": "static-7.1082",
    "ro": "static-7.1082",
    "ru": "static-7.1082",
    "sk": "static-7.1082",
    "sl": "static-7.1082",
    "sv": "static-7.1082",
    "th": "static-7.1082",
    "tl": "static-7.1082",
    "tr": "static-7.1082",
    "uk": "static-7.1082",
    "vi": "static-7.1082",
    "x-pseudo": "static-7.1082",
    "zh-cn": "static-7.1082",
    "zh-hk": "static-7.1082",
    "zh-tw": "static-7.1082"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:bg', {version: 'static-7.1082'}); }
})();


